window.setTimeout(function() {
  let lastFocusedElement = null;
  let currentOpenButton = null;
  let usingKeyboard = false;
  let mouseDownTime = 0;

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Tab' || e.key === 'Enter' || e.key === ' ' || e.key.startsWith('Arrow')) {
      usingKeyboard = true;
    }
  });

  document.addEventListener('mousedown', function(e) {
    usingKeyboard = false;
    mouseDownTime = Date.now();
    document.querySelectorAll('.focus').forEach(el => el.classList.remove('focus'));
  });

  document.addEventListener('click', function(e) {
    usingKeyboard = false;
    e.target.classList.remove('focus');
  });

  function initializeSizeGuideTableNavigation(modal) {
    if (!modal) return;
    const table = modal.querySelector('.size-guide-table');
    if (!table) return;

    const existingCells = table.querySelectorAll('th[tabindex="0"], td[tabindex="0"]');
    existingCells.forEach((cell) => {
      const newCell = cell.cloneNode(true);
      cell.parentNode.replaceChild(newCell, cell);
    });

    const focusableElements = table.querySelectorAll('th[tabindex="0"], td[tabindex="0"]');
    const cells = Array.from(focusableElements);
    const rows = [];
    let currentRow = [];

    cells.forEach((cell) => {
      const row = cell.closest('tr');
      if (currentRow.length === 0 || currentRow[0].closest('tr') === row) {
        currentRow.push(cell);
      } else {
        rows.push([...currentRow]);
        currentRow = [cell];
      }
    });
    if (currentRow.length > 0) {
      rows.push(currentRow);
    }

    function getCurrentPosition(element) {
      for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
        const colIndex = rows[rowIndex].indexOf(element);
        if (colIndex !== -1) {
          return { row: rowIndex, col: colIndex };
        }
      }
      return { row: 0, col: 0 };
    }

    function focusCell(rowIndex, colIndex) {
      if (rowIndex >= 0 && rowIndex < rows.length &&
          colIndex >= 0 && colIndex < rows[rowIndex].length) {
        rows[rowIndex][colIndex].focus();
        return true;
      }
      return false;
    }

    cells.forEach((cell) => {
      cell.addEventListener('keydown', function(event) {
        const position = getCurrentPosition(this);
        let handled = false;

        switch (event.key) {
          case 'ArrowRight':
            handled = focusCell(position.row, position.col + 1);
            break;
          case 'ArrowLeft':
            handled = focusCell(position.row, position.col - 1);
            break;
          case 'ArrowDown':
            handled = focusCell(position.row + 1, position.col);
            break;
          case 'ArrowUp':
            handled = focusCell(position.row - 1, position.col);
            break;
          case 'Home':
            if (event.ctrlKey) {
              handled = focusCell(0, 0);
            } else {
              handled = focusCell(position.row, 0);
            }
            break;
          case 'End':
            if (event.ctrlKey) {
              handled = focusCell(rows.length - 1, rows[rows.length - 1].length - 1);
            } else {
              handled = focusCell(position.row, rows[position.row].length - 1);
            }
            break;
        }

        if (handled) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    });
  }

  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('btn-sizeguide-trigger') || e.target.closest('.btn-sizeguide-trigger')) {
      document.body.classList.add('open-size-guide-popup');
      document.documentElement.classList.add('open-size-guide-popup');
    }

    if (e.target.classList.contains('size-guide-overlay') || e.target.closest('.size-guide-overlay')) {
      const modal = e.target.closest('.size-chart-modal-desktop, .size-chart-modal-mobile');
      if (modal) {
        modal.setAttribute('hidden', 'hidden');
        modal.removeAttribute('tabindex');
        document.body.classList.remove('open-size-guide-popup');
        document.documentElement.classList.remove('open-size-guide-popup');

        if (currentOpenButton) {
          currentOpenButton.setAttribute('aria-expanded', 'false');
          currentOpenButton = null;
        }

        if (lastFocusedElement && usingKeyboard) {
          lastFocusedElement.focus();
          lastFocusedElement = null;
        } else {
          lastFocusedElement = null;
        }
      } else {
        document.body.classList.remove('open-size-guide-popup');
        document.documentElement.classList.remove('open-size-guide-popup');
      }
    }

    if (e.target.classList.contains('close-size-guide-popup') || e.target.closest('.close-size-guide-popup')) {
      const modal = e.target.closest('.size-chart-modal-desktop, .size-chart-modal-mobile');
      if (modal) {
        modal.setAttribute('hidden', 'hidden');
        modal.removeAttribute('tabindex');
        document.body.classList.remove('open-size-guide-popup');
        document.documentElement.classList.remove('open-size-guide-popup');

        if (currentOpenButton) {
          currentOpenButton.setAttribute('aria-expanded', 'false');
          currentOpenButton = null;
        }

        if (lastFocusedElement && usingKeyboard) {
          lastFocusedElement.focus();
          lastFocusedElement = null;
        } else {
          lastFocusedElement = null;
        }
      } else {
        document.body.classList.remove('open-size-guide-popup');
        document.documentElement.classList.remove('open-size-guide-popup');
      }
    }

    if (e.target.classList.contains('size-chart-button-desktop') || e.target.closest('.size-chart-button-desktop')) {
      e.preventDefault();
      const button = e.target.classList.contains('size-chart-button-desktop') ? e.target : e.target.closest('.size-chart-button-desktop');

      const modalTarget = button.getAttribute('data-modal-target');
      const modal = document.querySelector(`.size-chart-modal-desktop[data-modal-id="${modalTarget}"], .size-chart-modal-mobile[data-modal-id="${modalTarget}"]`);

      if (!modal) return;

      lastFocusedElement = document.activeElement;
      currentOpenButton = button;

      document.querySelectorAll('.size-chart-button-desktop').forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
      });
      button.setAttribute('aria-expanded', 'true');

      modal.removeAttribute('hidden');
      modal.setAttribute('tabindex', '-1');
      document.body.classList.add('open-size-guide-popup');
      document.documentElement.classList.add('open-size-guide-popup');

      setTimeout(function() {
        initializeSizeGuideTableNavigation(modal);

        if (usingKeyboard) {
          modal.focus();

          const closeBtn = modal.querySelector('.close-size-guide-popup');
          if (closeBtn && !closeBtn.hasAttribute('tabindex')) {
            closeBtn.setAttribute('tabindex', '0');
          }
          if (closeBtn) {
            closeBtn.focus();
          }
        } else {
          const closeBtn = modal.querySelector('.close-size-guide-popup');
          if (closeBtn && !closeBtn.hasAttribute('tabindex')) {
            closeBtn.setAttribute('tabindex', '0');
          }
        }
      }, 100);
    }
  });

  document.addEventListener('keydown', function(e) {
    const closeBtns = document.querySelectorAll('.size-chart-modal-desktop .close-size-guide-popup, .size-chart-modal-mobile .close-size-guide-popup');
    closeBtns.forEach(btn => {
      if (e.target === btn && e.key === 'Enter') {
        e.preventDefault();
        btn.click();
      }
    });
  });

  document.addEventListener('keydown', function(e) {
    let activeModal = null;
    const openModals = document.querySelectorAll('.size-chart-modal-desktop:not([hidden]), .size-chart-modal-mobile:not([hidden])');

    openModals.forEach(function(modal) {
      if (modal.contains(document.activeElement)) {
        activeModal = modal;
      }
    });

    if (!activeModal && openModals.length > 0) {
      activeModal = openModals[0];
    }

    if (activeModal) {
      if (e.key === 'Escape') {
        e.preventDefault();
        const closeBtn = activeModal.querySelector('.close-size-guide-popup');
        if (closeBtn) closeBtn.click();
        return;
      }

      if (e.key === 'Tab') {
        const focusableSelectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const focusableElements = activeModal.querySelectorAll(focusableSelectors);
        const focusableArray = Array.from(focusableElements).filter(function(el) {
          return !el.disabled && el.offsetParent !== null;
        });

        if (focusableArray.length === 0) return;

        const firstFocusable = focusableArray[0];
        const lastFocusable = focusableArray[focusableArray.length - 1];

        if (e.shiftKey) {
          if (document.activeElement === firstFocusable) {
            e.preventDefault();
            lastFocusable.focus();
          }
        } else {
          if (document.activeElement === lastFocusable) {
            e.preventDefault();
            firstFocusable.focus();
          }
        }
      }
    }
  });

  document.addEventListener('focusin', function(e) {
    const timeSinceMouseDown = Date.now() - mouseDownTime;
    const isRecentMouseInteraction = timeSinceMouseDown < 100;

    if (usingKeyboard && !isRecentMouseInteraction) {
      e.target.classList.add('focus');
    } else {
      e.target.classList.remove('focus');
    }

    const openModals = document.querySelectorAll('.size-chart-modal-desktop:not([hidden]), .size-chart-modal-mobile:not([hidden])');
    if (openModals.length > 0) {
      let targetModal = null;
      openModals.forEach(function(modal) {
        if (modal.contains(e.target)) {
          targetModal = modal;
        }
      });

      if (!targetModal) {
        const modal = openModals[0];
        e.preventDefault();
        e.stopPropagation();

        const focusableSelectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const firstFocusable = modal.querySelector(focusableSelectors);

        if (firstFocusable) {
          firstFocusable.focus();
        } else {
          modal.focus();
        }
      }
    }
  });

  document.addEventListener('focusout', function(e) {
    e.target.classList.remove('focus');
  });
}, 50);
